import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Searchbar = () => {
    const navigate = useNavigate();
    const [keyword, setkeyword] = useState("");

    const formvalue = (event) => {
        setkeyword(event.target.value.toLowerCase());
        console.log(keyword)

    }

    const search = (event) => {
        event.preventDefault();
        navigate(`/search/${keyword}`)
    }

    return (
        <nav class="navbar navbar-light bg-light">
            <div class="container-fluid">
                <form class="d-flex" onSubmit={search}>
                    <input class="form-control me-2" onChange={formvalue} type="search" placeholder="Search" aria-label="Search" />
                    <button class="btn btn-secondary  searchbutton" type="submit">Search</button>
                </form>
            </div>
        </nav>

    )
}
export default Searchbar;